import React from 'react';
import { CheckSquare, Phone, StickyNote, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';

import ScopeDot from './ScopeDot';
import {
  ITEM_TYPE_ICON, ITEM_TYPE_LABEL, PRIORITY_COLOR,
  formatEuro, getItemRoute, isItemDueToday,
} from './dashboardHelpers';

const PlanItemRow = ({ item, todayStr, onQuickCall, onQuickNote, onToggleDone, navigate, compact, readOnly = false }) => {
  const Icon = ITEM_TYPE_ICON[item.item_type] || CheckSquare;
  const dueToday = isItemDueToday(item, todayStr);
  const colorCls = dueToday ? 'text-orange-600' : PRIORITY_COLOR[item.priority] || 'text-blue-500';
  const done = item.done || item.completed_in_plan;

  return (
    <div
      className={`group flex items-start gap-2 px-2 py-1.5 rounded-md hover:bg-muted/60 transition-colors border ${done ? 'opacity-50 bg-muted/30' : ''}`}
      data-testid={`plan-item-${item.item_type}-${item.item_id}`}
    >
      <Icon className={`w-4 h-4 flex-shrink-0 mt-0.5 ${colorCls}`} />
      <button
        type="button"
        onClick={() => navigate(getItemRoute(item))}
        className="flex-1 min-w-0 text-left"
      >
        <p className={`text-sm font-medium truncate ${done ? 'line-through' : ''} flex items-center`}>
          <ScopeDot scope={item.scope} />
          <span className="truncate">{item.title || '(sin título)'}</span>
        </p>
        <p className="text-[10px] text-muted-foreground flex items-center gap-1 flex-wrap">
          <span>{ITEM_TYPE_LABEL[item.item_type]}</span>
          {item.priority === 'high' && <span className="text-orange-600 font-medium">· Alta</span>}
          {item.due_date && <span>· {item.due_date.slice(0, 10)}</span>}
          {item.estimated_value && <span>· {formatEuro(item.estimated_value)}</span>}
          {item.stage && <span>· {item.stage}</span>}
        </p>
      </button>
      {!compact && !readOnly && (
        <div className={`flex items-center gap-0.5 flex-shrink-0 transition-opacity ${done ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'}`}>
          <Button
            size="icon"
            variant="ghost"
            className="h-7 w-7"
            onClick={(e) => { e.stopPropagation(); onToggleDone(item); }}
            title={done ? 'Desmarcar (volver a pendiente)' : 'Marcar hecho'}
            data-testid={`plan-item-done-${item.item_id}`}
          >
            <Check className={`w-3.5 h-3.5 ${done ? 'text-slate-400' : 'text-green-600'}`} />
          </Button>
          {!done && (
            <>
              <Button
                size="icon"
                variant="ghost"
                className="h-7 w-7"
                onClick={(e) => { e.stopPropagation(); onQuickCall(item); }}
                title="Registrar llamada"
                data-testid={`plan-item-call-${item.item_id}`}
              >
                <Phone className="w-3.5 h-3.5 text-blue-500" />
              </Button>
              <Button
                size="icon"
                variant="ghost"
                className="h-7 w-7"
                onClick={(e) => { e.stopPropagation(); onQuickNote(item); }}
                title="Añadir nota"
                data-testid={`plan-item-note-${item.item_id}`}
              >
                <StickyNote className="w-3.5 h-3.5 text-slate-500" />
              </Button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PlanItemRow;
